import { z } from "zod";
import { PaginationRequestSchema, PaginationResponseSchema } from "./pagination";

// ======================
// POOL PARTICIPANT QUERY
// ======================
export const PoolParticipantQuerySchema = PaginationRequestSchema.extend({
  poolId: z.string().optional(),
  userId: z.string().optional(),
});
export type PoolParticipantQueryDTO = z.infer<typeof PoolParticipantQuerySchema>;

// ======================
// POOL PARTICIPANTS
// ======================
export const PoolParticipantResponseSchema = z.object({
  poolId: z.string(),
  userId: z.string(),
  role: z.string(),
  statusId: z.string(),
  joinedAt: z.coerce.date().nullable(),
  exitReason: z.string().nullable(),
  updatedAt: z.coerce.date(),
  createdAt: z.coerce.date(),
});
export type PoolParticipantResponseDTO = z.infer<
  typeof PoolParticipantResponseSchema
>;

export const PoolParticipantsPaginatedResponseSchema = PaginationResponseSchema(
  PoolParticipantResponseSchema,
);
export type PoolParticipantsPaginatedResponseDTO = z.infer<
  typeof PoolParticipantsPaginatedResponseSchema
>;

export const AddPoolParticipantRequestSchema = z.object({
  poolId: z.string().min(1),
  userId: z.string().min(1),
  role: z.string().optional().default("player"),
});
export type AddPoolParticipantRequestDTO = z.infer<
  typeof AddPoolParticipantRequestSchema
>;

export const UpdatePoolParticipantRequestSchema = z.object({
  statusId: z.string().optional(),
  role: z.string().optional(),
  joinedAt: z.coerce.date().optional().nullable(),
  exitReason: z.string().optional().nullable(),
});
export type UpdatePoolParticipantRequestDTO = z.infer<
  typeof UpdatePoolParticipantRequestSchema
>;

export const JoinPoolRequestSchema = z.object({
  codeOrToken: z.string().min(1),
});
export type JoinPoolRequestDTO = z.infer<typeof JoinPoolRequestSchema>;
